var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _PostSurgerySurveyFilledJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import { validateInclusion } from "ember-changeset-validations/validators";
import { IntlService } from "ember-intl";
import BaseSurgerySurveyFilledJournalEvent, { TreatmentSectionWithColor } from "./base-surgery-survey-filled-journal-event";
import Patient from "./patient";
//---- Automatically generated, don't update this part ----
/**
 * Represents a pre surgery survey filled related to RAAC onco.
 */
let PostSurgerySurveyFilledJournalEvent = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("string"), _dec6 = attr("string"), _dec7 = attr("string"), _dec8 = attr("string"), _dec9 = attr("boolean", {
  allowNull: true
}), _dec10 = attr("boolean", {
  allowNull: true
}), _dec11 = attr("boolean", {
  allowNull: true
}), _dec12 = attr("string"), _dec13 = attr("string"), _dec14 = attr("string"), _dec15 = attr("boolean", {
  allowNull: true
}), _dec16 = attr("string"), _dec17 = attr("number"), _dec18 = belongsTo("patient", {
  async: false,
  inverse: "postSurgerySurveyFilledJournalEvents"
}), _class = (_PostSurgerySurveyFilledJournalEvent = class PostSurgerySurveyFilledJournalEvent extends BaseSurgerySurveyFilledJournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "eatingRecovery", _descriptor, this);
    _initializerDefineProperty(this, "activityRecovery", _descriptor2, this);
    _initializerDefineProperty(this, "nauseaOrVomiting", _descriptor3, this);
    _initializerDefineProperty(this, "painSinceBackHome", _descriptor4, this);
    _initializerDefineProperty(this, "digestiveRecovery", _descriptor5, this);
    _initializerDefineProperty(this, "difficultiesToUrinate", _descriptor6, this);
    _initializerDefineProperty(this, "temperatureLevel", _descriptor7, this);
    _initializerDefineProperty(this, "bleedingOnWound", _descriptor8, this);
    _initializerDefineProperty(this, "woundInflammation", _descriptor9, this);
    _initializerDefineProperty(this, "woundFlow", _descriptor10, this);
    _initializerDefineProperty(this, "calfPain", _descriptor11, this);
    _initializerDefineProperty(this, "systolicBloodPressure", _descriptor12, this);
    _initializerDefineProperty(this, "diastolicBloodPressure", _descriptor13, this);
    _initializerDefineProperty(this, "pulse", _descriptor14, this);
    _initializerDefineProperty(this, "hasAlertingValue", _descriptor15, this);
    _initializerDefineProperty(this, "originTaskIdentifier", _descriptor16, this);
    _initializerDefineProperty(this, "score", _descriptor17, this);
    _initializerDefineProperty(this, "patient", _descriptor18, this);
  }
  static validations(intl) {
    return {
      ...this.baseValidations(intl),
      systolicBloodPressure: validateInclusion({
        list: ["0", "1"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.systolic-blood-pressure")
      }),
      diastolicBloodPressure: validateInclusion({
        list: ["0", "1"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.diastolic-blood-pressure")
      }),
      pulse: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.pulse")
      }),
      eatingRecovery: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.eating-recovery")
      }),
      activityRecovery: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.activity-recovery")
      }),
      nauseaOrVomiting: validateInclusion({
        list: ["0", "1", "2", "3"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.nausea-or-vomiting")
      }),
      painSinceBackHome: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.pain-since-back-home")
      }),
      digestiveRecovery: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.digestive-recovery")
      }),
      difficultiesToUrinate: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.difficulties-to-urinate")
      }),
      temperatureLevel: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.temperature-level")
      }),
      bleedingOnWound: validateInclusion({
        list: ["0", "1", "2"],
        allowBlank: true,
        description: intl.t("validations.post-surgery-survey-filled-journal-event.bleeding-on-wound")
      })
    };
  }

  //---- End of generated code ----

  get sectionsWithColor() {
    const scoreValues = {
      eatingRecovery: {
        "0": 0,
        "1": 10,
        "2": 100
      },
      activityRecovery: {
        "0": 0,
        "1": 30,
        "2": 100
      },
      nauseaOrVomiting: {
        "0": 0,
        "1": 10,
        "2": 30,
        "3": 100
      },
      painSinceBackHome: {
        "0": 0,
        "1": 30,
        "2": 100
      },
      digestiveRecovery: {
        "0": 0,
        "1": 30,
        "2": 100
      },
      difficultiesToUrinate: {
        "0": 0,
        "1": 30,
        "2": 100
      },
      temperatureLevel: {
        "0": 0,
        "1": 30,
        "2": 100
      },
      bleedingOnWound: {
        "0": 0,
        "1": 30,
        "2": 100
      },
      woundInflammation: {
        true: 100,
        false: 0
      },
      woundFlow: {
        true: 100,
        false: 0
      },
      calfPain: {
        true: 100,
        false: 0
      },
      systolicBloodPressure: {
        "0": 100,
        "1": 0
      },
      diastolicBloodPressure: {
        "0": 100,
        "1": 0
      },
      pulse: {
        "0": 0,
        "1": 100,
        "2": 0
      }
    };
    return this.computeSectionsWithColor(PostSurgerySurveyFilledJournalEvent.sections, scoreValues);
  }
}, _defineProperty(_PostSurgerySurveyFilledJournalEvent, "type", "post-surgery-survey-filled-journal-event"), _defineProperty(_PostSurgerySurveyFilledJournalEvent, "sections", ["eatingRecovery", "activityRecovery", "nauseaOrVomiting", "painSinceBackHome", "digestiveRecovery", "difficultiesToUrinate", "temperatureLevel", "bleedingOnWound", "woundInflammation", "woundFlow", "calfPain", "systolicBloodPressure", "diastolicBloodPressure", "pulse"]), _PostSurgerySurveyFilledJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "eatingRecovery", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "activityRecovery", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "nauseaOrVomiting", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "painSinceBackHome", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "digestiveRecovery", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "difficultiesToUrinate", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "temperatureLevel", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "bleedingOnWound", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "woundInflammation", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "woundFlow", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "calfPain", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "systolicBloodPressure", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "diastolicBloodPressure", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "pulse", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "hasAlertingValue", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "originTaskIdentifier", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "score", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PostSurgerySurveyFilledJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.